// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiSnackbar-root{padding:11px 18px}.MuiPaper-root.MuiSnackbarContent-root{background-color:var(--main-header-color);font-size:14px;line-height:21px;font-weight:400;color:#fff;min-width:260px}.MuiPaper-root.MuiSnackbarContent-root .undo-button{color:var(--primary-color-click-3)}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
